import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { HorizontalTabNav } from 'components/common/horizontalTabNav';
import { PERMISSIONS } from 'constants/permissions';
import { ADMIN_ROUTES } from 'constants/routes';

export const TabNav = React.memo(() => {
  const { pathname } = useLocation();
  const { hasAccess } = useAccessControl();

  const navigationItems = useMemo(() => {
    const items = [
      {
        path: ADMIN_ROUTES.purchaseRequest.general,
        label: 'General',
        permission: PERMISSIONS.purchaseRequests.tabs.general.read,
        id: 'PR-1',
      },
      {
        path: ADMIN_ROUTES.purchaseRequest.supplierOffers,
        label: 'Supplier Offers',
        permission: PERMISSIONS.purchaseRequests.tabs.supplierOffers.read,
        id: 'PR-2',
      },
      {
        path: ADMIN_ROUTES.purchaseRequest.tasks,
        label: 'Tasks',
        permission: PERMISSIONS.purchaseRequests.tabs.task.read,
        id: 'PR-3',
      },
      {
        path: ADMIN_ROUTES.purchaseRequest.communicationHub,
        label: 'Communication Hub',
        permission: PERMISSIONS.purchaseRequests.tabs.communicationHub.read,
        id: 'PR-4',
      },
      {
        path: ADMIN_ROUTES.purchaseRequest.attachments,
        label: 'Attachments',
        permission: PERMISSIONS.purchaseRequests.tabs.attachment.read,
        id: 'PR-5',
      },
      {
        path: ADMIN_ROUTES.purchaseRequest.logs,
        label: 'Logs',
        permission: PERMISSIONS.purchaseRequests.tabs.logs.read,
        id: 'PR-6',
      },
    ];

    return items.filter((i) => hasAccess(i.permission));
  }, [hasAccess]);

  return <HorizontalTabNav pathname={pathname} navigationItems={navigationItems} />;
});
